import React, { useEffect, useState } from "react";
import { classes, StyledDialog } from "./styles";

import {
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  InputAdornment,
  Alert,
  Tooltip,
} from "@mui/material";

import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import CloseIcon from "@mui/icons-material/Close";

const CredentialsModal = (props) => {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    if (props.credentials?.length > 0) {
      setClientId(props.credentials[0].clientId);
      setClientSecret(props.credentials[0].clientSecret);
    }
  }, [props.credentials]);

  return (
    <StyledDialog
      open={props.openModal}
      onClose={props.toggleModal}
      datacy={props.datacy}
    >
      <div className={classes.dialogTitleWrap}>
        <DialogTitle>{props.title}</DialogTitle>
        <IconButton
          onClick={props.toggleModal}
          datacy={"closeCredentialsModalButton"}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.dialogContent}>
        {props.description}
        <Alert severity={"warning"} className={classes.alert}>
          {props.alert}
        </Alert>
        <div className={classes.textFieldWrap}>
          {props.showClientId && (
            <TextField
              fullWidth={true}
              value={clientId}
              label={"Client ID"}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <Tooltip title={"Copy Client Id"}>
                      <IconButton
                        onClick={() => props.copyCredentials(clientId, false)}
                        size="small"
                      >
                        <FileCopyOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              datacy={"apiCredsClientIdInput"}
              sx={{ marginBottom: "20px" }}
            />
          )}
          <TextField
            fullWidth={true}
            value={clientSecret}
            label={"Client Secret"}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position={"end"}>
                  <Tooltip title={"Copy Client Secret"}>
                    <IconButton
                      onClick={() => props.copyCredentials(clientSecret, true)}
                    >
                      <FileCopyOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            datacy={"apiCredsClientSecretInput"}
          />
        </div>
      </DialogContent>
    </StyledDialog>
  );
};

export default CredentialsModal;
